import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';
import { tipoImpressaoCupom } from '../../util/constantsUtil';

class PrintContent extends Component {
  render() {
    const { referencias, referenciasCheckeds } = this.props;
    // Filtra apenas as referências que estão marcadas (checked: true)
    const referenciasMarcadas = referenciasCheckeds
      .filter(ref => ref.checked)
      .map(ref => ref.key);
    
    // Verifica se todos os elementos DOM estão prontos
    const elementosProntos = referenciasMarcadas.every(refId => {
      const referencia = referencias.get(refId);
      return referencia && referencia.referencia && referencia.referencia.current;
    });
    
    // Se os elementos não estão prontos, retorna um div vazio
    if (!elementosProntos) {
      return <div></div>;
    }
    
    return (
      <div>
        {referenciasMarcadas.map((refId) => {
          const referencia = referencias.get(refId);
          return (
            <div
              key={refId}
              dangerouslySetInnerHTML={{
                __html: referencia.referencia.current.outerHTML,
              }}
            />
          );
        })}
      </div>
    );
  }
}

export default class ModalImpressaoCupomBagagem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      referenciaSelecionada: [],
      isPrinting: false,
    };
  }

  componentDidMount() {
    // Inicializa com todas as referências selecionadas por padrão
    if (this.props.referencias) {
      const todasReferencias = [...this.props.referencias.keys()];
      this.setState({ referenciaSelecionada: todasReferencias });
    }
  }

  componentDidUpdate(prevProps) {
    // Atualiza quando as referências mudam
    if (prevProps.referencias !== this.props.referencias && this.props.referencias) {
      const todasReferencias = [...this.props.referencias.keys()];
      this.setState({ referenciaSelecionada: todasReferencias });
    }
  }

  adicionarChebox(ref) {
    let referenciaSelecionada = Object.assign([], this.state.referenciaSelecionada);
    if (referenciaSelecionada.length === 0 || referenciaSelecionada.filter(it => it === ref).length === 0) {
      referenciaSelecionada.push(ref);
      this.setState({ referenciaSelecionada: referenciaSelecionada });
    } else {
      referenciaSelecionada = referenciaSelecionada.filter(it => !(it === ref));
      this.setState({ referenciaSelecionada: referenciaSelecionada });
    }

    this.props.marcarReferencia(ref);
  }

  exibirTiposImpressao() {
    return (
      <div style={{ marginLeft: '30px' }}>
        {[...this.props.referencias.keys()].map((ref) => (
          <div className="row mt-2" key={ref}>
            <div>
              <input
                type="checkbox"
                onChange={() => this.adicionarChebox(ref)}
                checked={this.props.referenciasCheckeds.filter(it => it.key === ref)[0]?.checked || false}
              />
              <span className="ml-2">{this.props.referencias.get(ref).nome}</span>
              <br />
            </div>
          </div>
        ))}
      </div>
    );
  }

  handlePrint() {
    this.setState({ isPrinting: true }, () => {
      // Aguarda mais tempo para garantir que os elementos DOM estejam prontos
      setTimeout(() => {
        // Força uma re-renderização do PrintContent
        this.forceUpdate();
        setTimeout(() => {
          window.print();
          this.setState({ isPrinting: false });
        }, 100);
      }, 1000);
    });
  }

  exibirBotaoImprimir() {
    if (this.props.tipo === tipoImpressaoCupom.normal) {
      return (
        <button
          disabled={!this.props.pagina}
          onClick={() => this.props.pagina.print()}
          className="btn btn-laranja"
        >
          IMPRIMIR
        </button>
      );
    }

    if (this.props.tipo === tipoImpressaoCupom.termica) {
      const { referenciaSelecionada } = this.state;
      const { referencias } = this.props;
      const temReferenciasSelecionadas = referenciaSelecionada.length <= 0;

      return (
        <React.Fragment>
          <ReactToPrint
            trigger={() => (
              <button
                className="btn btn-laranja"
                disabled={temReferenciasSelecionadas}
                onClick={this.handlePrint.bind(this)}
              >
                IMPRIMIR
              </button>
            )}
            content={() => this.printComponent}
            documentTitle={'cupom-bagagem'}
          />
          <br />
          <div style={{ display: 'none' }}>
            <PrintContent
              ref={(el) => (this.printComponent = el)}
              referencias={referencias}
              referenciasCheckeds={this.props.referenciasCheckeds}
            />
          </div>
        </React.Fragment>
      );
    }

    return '';
  }

  limparTudo() {
    this.setState({ referenciaSelecionada: [] });
    this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal);
    this.props.limparMarcacaoReferenciasCheckeds();
    this.props.habilitarDesabilitarReciboCupomBagagem(false);
  }

  render() {
    return (
        <div className="modal fade show" id='modalImpressaoCupomBagagem' role='dialog'
         aria-labelledby='modalImpressaoCupomBagagem' aria-hidden='true' data-backdrop='static'>
      <div className={'modal-dialog modal-dialog-centered modal-md'}>
        <div className="modal-content">
          <div className="modal-header">
            <h5>Selecione o tipo de impressão que deseja</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                    onClick={() => this.limparTudo()}>
              <i className="material-icons">
                &#xe5cd;
              </i>
            </button>
          </div>
          <div className="modal-body">
            <input type="radio" onChange={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal)}
                checked={this.props.tipo === tipoImpressaoCupom.normal} /> Normal <br/>
            <input type="radio" onChange={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.termica)}
                checked={this.props.tipo === tipoImpressaoCupom.termica}/> Térmica
            {this.props.tipo === tipoImpressaoCupom.termica && <div>
              {this.exibirTiposImpressao()}
            </div>}
          </div>
          <div className="modal-footer">
            {this.exibirBotaoImprimir()}
          </div>
        </div>
      </div>
    </div>
    )
  }
}
